import React, { Component } from "react";

import { FiArrowUp } from "react-icons/fi";
import { Fonts } from "Themes";
import { LazyLoadImage } from "react-lazy-load-image-component";
import styled from "styled-components";

export const SideProjectContainer = styled.div`
  padding: 0px;
  margin: 20px;
  width: 200px;
  height: 250px;
  display: flex;
  border: ${props => props.showTitle ? "solid 2px lightgray" : "none"}
  border-radius: 10px;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  overflow: hidden;
  &: hover {
    opactiy: 0.5;
  }
`;

export const SideProjectTitle = styled.div`
  padding: 10px;
  font-family: ${Fonts.primaryFontFamily};
  background-color: white;
  font-size: ${Fonts.size.medium}px
  border-bottom: solid 2px ligthgray;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
  z-index: 1;
  width: 100%;
`;

export const IconContainer = styled.div`
  display: none;
  border: solid 2px lightgray;
  border-radius: 10px;
  padding: 10px;
  background-color: white;
`;

export const SideProjectImage = styled.div`
  height: 200px;
  width: 200px;
  margin: 0px;
  z-index: 2;
  display: flex;
  justify-content: center;
  align-items: center;
  border-right-bottom-radius: 0px;
  &:hover {
    opacity: 0.7;
  }
  &:hover ${IconContainer} {
    opactiy: 1;
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    border: solid 2px black;
  }
`;
const ScoreContainer = styled.div`
  position: absolute;
  z-index: 9;
  font-size: ${Fonts.fontSize.medium}px;
  height: 50px;
  width: 50px;
`;

const SideProjectScore = styled.div`
  position: absolute;
  top: -25px;
  border: solid 2px lightgray;
  height: 50px;
  width: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  background-color: white;
`;

class SideProject extends Component {
  state = {};

  renderProjectTitle = (title) => {
    let formattedTitle = title;
    if (title.length > 30) {
      formattedTitle = `${title
        .split("")
        .splice(0, 30)
        .join("")}...`;
    }
    return formattedTitle;
  };

  render() {
    const { onClick, project, showRating, showTitle } = this.props;

    return (
      <SideProjectContainer onClick={onClick} showTitle={showTitle}>
        <ScoreContainer>
          {showRating && (
            <SideProjectScore>
              <FiArrowUp fontSize={20} /> {project.overallRating}
            </SideProjectScore>
          )}
        </ScoreContainer>
        <SideProjectImage>
          <LazyLoadImage
            alt={"Not found"}
            height={200}
            src={project.projectAvatar}
            width={200}
            style={{
              borderRadius: 10,
              borderBottomRightRadius: showTitle && showRating ? 0 : 10,
              borderBottomLeftRadius: showTitle && showRating ? 0 : 10,
            }}
          />
        </SideProjectImage>
        {showTitle && (
          <SideProjectTitle>
            {this.renderProjectTitle(project.projectName)}
          </SideProjectTitle>
        )}
      </SideProjectContainer>
    );
  }
}

export default SideProject;
